module.exports = __webpack_public_path__ + "img/doorpostscene2.3235d5c4.png";